module.exports = __webpack_public_path__ + "7fdb308e32e57960988f1decd4a575e7.png";